import React, { PureComponent } from "react";
import { connect } from "react-redux";
import "./index.css";
import Draggable from "react-draggable";
import { Toggle } from "office-ui-fabric-react/lib-commonjs/Toggle";
import { ChoiceGroup } from "office-ui-fabric-react/lib/ChoiceGroup";
import { ComboBox } from "office-ui-fabric-react/lib-commonjs/ComboBox";
import {
  Checkbox,
  Dialog,
  DialogType,
  PrimaryButton,
  SpinButton
} from "office-ui-fabric-react";
import { ManifoldDirection, ManifoldSpacer } from "../../lib/manifolds";
import {
  changeMainManifoldProp,
  renderLowerManifolds,
  renderMainManifolds,
  renderUpperManifolds
} from "../../actions/manifold-actions";
import {
  setChamberLowerCapAccesory,
  setChamberUpperCapAccesory,
  setManifoldIsolatorRowStatus
} from "../../actions/floating-tool-actions";
import {
  closeManifoldEntryDialog,
  closeRemovalPromptDialog,
  manifoldEntryMoved,
  removeManifold,
  removeOverlappingManifold,
  setCheckForOverlap,
  setCurrentManifold,
  setOverlapPresent,
  showManifoldEntryDialog,
  toggleOverlapDialog
} from "../../actions/manifold-entry-actions";
import { switchToAddMode } from "../../actions/drawingtoolbar-actions";
import { unitIds } from "../../lib/localization/unitIds";
import { CHAMBER_TYPE_ID_SC160LP } from "../../lib/types";
import { ManifoldUtils } from "../../lib/manifolds/utils";
import { DialogFooter } from "office-ui-fabric-react/lib-commonjs/Dialog";
import { DefaultButton } from "office-ui-fabric-react/lib-commonjs/Button";
import PopUpHelper from "../Calculations/popUpHelper.component";
import { languageIds } from "../../lib/localization/languageIds";
import ManifoldSelectors from "../../reducers/main-manifold-reducer";
import ManifoldService from "../../lib/services/manifold-service";
import {
  activateByArray,
  cleanChambersByArrayIsolator,
  cleanChambersByManifoldMainRowArray,
  cleanChambersByManifoldVoidArray,
  deactivateByArray,
  modifyChambersByArray,
  modifyChambersByArrayIsolator,
  modifyChambersByManifoldVoidArray,
  setChamberKeyValue, setInsertaTeeWarningType, showInsertaTeeWarning
} from "../../actions/chamber-actions";
import { modalAlertActions } from "../../actions/modal-alert.actions";
import IsolatorService from "../../lib/services/isolator_service";
import produce from "immer";
import ChamberService from "../../lib/services/chambers-service";

export const ManifoldEntryFormValueType = {
  DIRECTION: "DIRECTION",
  NUMBER_OF_STUBS: "NUMBER_OF_STUBS",
  SAME_NUMBER_OF_STUBS: "SAME_NUMBER_OF_STUBS",
  GAP: "GAP",
  IS_ISOLATOR_ROW: "IS_ISOLATOR_ROW",
  IS_MANIFOLD_ISOLATOR_ROW: "IS_MANIFOLD_ISOLATOR_ROW",
  MANIFOLD_SIZE: "MANIFOLD_SIZE",
  HAS_WEIR: "HAS_WEIR",
  HAS_ELEVATED_MANIFOLD: "HAS_ELEVATED_MANIFOLD",
  STRUCTURE_TYPE: "STRUCTURE_TYPE",
  HAS_SECOND_PIPE: "HAS_SECOND_PIPE",
  USER_MODIFIED: "USER_MODIFIED"
};

class ManifoldEntry extends PureComponent{
  state = this.getInitialState();

  /**
   * Returns the reseated state of the Manifold Object
   * @returns {{
   *  manifold: null,
   *  isIsolator: boolean,
   *  hasElevatedManifold: boolean,
   *  hasWeir: boolean,
   *  manifoldDirection: number,
   *  numberOfStubs: number,
   *  spacer: boolean,
   *  isUpperManifold: boolean,
   *  selectedManifoldSize: string,
   *  disableWeir: boolean,
   *  disableElevatedManifold: boolean,
   *  disableSecondPipe: boolean
   * }}
   */
  getInitialState() {
    return {
      manifold: null,
      isIsolator: false,
      hasElevatedManifold: false,
      hasWeir: false,
      manifoldDirection: ManifoldDirection.Left,
      numberOfStubs: 0,
      spacer: false,
      isUpperManifold: true,
      selectedManifoldSize: "",
      previousManifoldSize: "",
      disableWeir: false,
      disableElevatedManifold: false,
      showRemovalPromptDialog: false,
      debug: false,
      overlappingManifold: null,
      isOlPresent: false,
      hasSecondPipe: false,
      disableSecondPipe: false,
      hasIsolator: false,
      includeImperviousLinerWaringError: false
    };
  }

  /**
   * Resets form state
   */
  resetState() {
    this.setState({ ...this.getInitialState() });
  }

  componentDidUpdate( prevProps, prevState ) {
    if (
      this.props.mainManifolds &&
      this.props.mainManifolds.length > 0 &&
      !this.props.mainManifolds.equals(prevProps.mainManifolds)
    ) {
      if (prevProps.manifoldId && !this.props.manifoldId) {
        this.setState({ manifold: null });
        this.props.closeManifoldEntryDialog();
      } else {
        this.refreshManifoldData();
      }
    }

    if (
      this.props.manifoldId &&
      this.props.mainManifolds.length > 0 &&
      this.props.mainManifolds.equals(prevProps.mainManifolds) &&
      this.props.manifoldId !== prevProps.manifoldId
    ) {
      this.refreshManifoldData();
    }

    if (
      this.props.accessory &&
      prevProps.accessory &&
      this.props.accessory.variant !== prevProps.accessory.variant
    ) {
      this.refreshManifoldData();
    }

    if (
      this.props.manifoldId &&
      this.props.mainManifolds.length < prevProps.mainManifolds.length &&
      this.props.manifoldId === prevProps.manifoldId
    ) {
      if (!ManifoldSelectors.getManifoldByIdFromMain(this.props.manifoldId)) {
        this.resetState();
        this.props.closeManifoldEntryDialog();
      }
    }

    if (
      this.props.checkForOverlap
      && this.state.manifold
      && this.state.manifold.id === this.props.manifoldId
    ) {
      this.detectOverlappingManifolds(prevProps, prevState);
    }

    // if !noWeir, and the value does not exist switch to the previous value
    if (
      this.state.hasWeir !== prevState.hasWeir
      && !this.state.hasWeir
      && this.props["accessory"] !== null
      && this.props["manifoldId"] !== null
    ) {
      const manifold = this.props["mainManifolds"].find(manifold => manifold._id === this.props["manifoldId"]);
      const isHigh = this.getIsHigh(manifold);
      const isNylo = this.props["accessory"].variant === "nyloplast";
      let manifoldDatasetArr = ManifoldUtils.getManifoldDatasetByChamberId(this.props["chamberType"].id, isHigh ? "high" : "low", isNylo);
      const obj = manifoldDatasetArr.find(( obj ) => {
        return obj.size === this.state.selectedManifoldSize;
      });
      if (!obj) {
        this.changeManifoldSize(this.state["previousManifoldSize"]);
      }
    }
    // if noWeir, save the previous value, to correct the size if needed
    if (this.state.hasWeir !== prevState.hasWeir && this.state.hasWeir) {
      this.setPreviousManifoldSize(this.state.selectedManifoldSize);
    }
  }

  /**
   * Sets the previous manifold size, used to correct the size of the manifold when switching weir
   * @param selectedSize
   */
  setPreviousManifoldSize = ( selectedSize ) => {
    const index = this.manifoldDataset.findIndex(( obj ) => obj.size === selectedSize);
    let previousObject;
    if (index !== -1) {
      //previousObject = this.manifoldDataset[index - 1];
      previousObject = this.manifoldDataset[0];
    }
    if (previousObject && previousObject.size) {
      this.setState({ previousManifoldSize: previousObject.size });
    }
  };

  /**
   * Refreshed manifold data for component state
   */
  refreshManifoldData() {
    try {
      const manifold = ManifoldSelectors.getManifoldByIdFromMain(this.props.manifoldId);
      if (manifold) {

        const isIsolator = manifold.hasIsolator || false;
        const bypassOpts = this.getCurrentByPassOptions(
          isIsolator,
          this.props.chamberType.id,
          this.props.accessory.variant
        );
        const hideElevated = !isIsolator && this.props.accessory.variant !== "nyloplast";
        const hideWeir = !isIsolator;

        const disableSecondPipe = !manifold.isManifoldInner
          || !this.props.chamberRows[manifold.letRow].chambers.find(c =>
            ( manifold.isUpper ? c.col < manifold.letColumn : c.col > manifold.letColumn )
            && c.active)
          || ManifoldService.secondPipeWouldHitManifold(
            this.props.mainManifolds,
            this.props.chamberRows[manifold.letRow],
            manifold.letColumn,
            manifold.isUpper
          );

        this.setState({
          manifold: manifold,
          isIsolator,
          manifoldDirection: manifold.direction,
          numberOfStubs: manifold.stubsNumber,
          spacer: manifold.spacer === ManifoldSpacer.gap,
          disableWeir: bypassOpts.disableWeir,
          disableElevatedManifold: bypassOpts.disableElevatedManifold,

          hasElevatedManifold: hideElevated
            ? false
            : manifold.userModified
              ? manifold.isElevated
              : bypassOpts.hasElevatedManifold,

          hasWeir: hideWeir
            ? false
            : manifold.userModified
              ? !manifold.isElevated
              : bypassOpts.hasWeir,

          isUpperManifold: manifold.isUpper,
          selectedManifoldSize: manifold.manifoldSize.size,
          hasIsolator: manifold.hasIsolator,
          hasSecondPipe: manifold.hasSecondPipe,
          disableSecondPipe
        });

        if (
          this.props.chamberType.id === CHAMBER_TYPE_ID_SC160LP
          && isIsolator
          && this.props.accessory.variant === "nyloplast"
        ) {
          if (manifold._isUpper) {
            this.props.setChamberUpperCapAccesory(
              manifold._letRow,
              manifold.letColumn,
              { ...this.props.accessory, variant: "round" });
          } else {
            this.props.setChamberLowerCapAccesory(
              manifold._letRow,
              manifold._letColumn,
              { ...this.props.accessory, variant: "round" });
          }
          // this.props.changeMainManifoldProp(this.props.manifoldId, true, ManifoldEntryFormValueType.HAS_WEIR);
        }
        this.props.setCurrentManifold(manifold);
      }
    } catch (error) {
      console.error(`ManifoldEntry.refreshManifoldData() ${error.message}`);
    }
  }

  /**
   * Detects is a new manifold wil overlap an existing one
   */
  detectOverlappingManifolds( prevProps, prevState ) {
    const currentManifold = ManifoldSelectors.getManifoldByIdFromMain(this.props["manifoldId"]);
    const rowsOccupiedByCurrentManifold = this.props["mainManifolds"]
      .map(manifold => {
        // Rules to consider and mark overlapped
        if (manifold.id === this.props["manifoldId"]) // Not the same Manifold
          return null;
        if (manifold._letColumn !== currentManifold._letColumn) // only on the same column
          return null;
        if (manifold._isUpper !== currentManifold._isUpper) // Only if they are on the same side
          return null;
        return {
          manifoldId: manifold.id,
          rowIndexes: ManifoldUtils.getRowsOccupiedByManifold(manifold)
        };
      }).filter(Boolean);

    const thisManifoldsRows = ManifoldUtils.getRowsOccupiedByManifold(currentManifold);

    let overlaps = [], hasOverlap = false;

    for (let i = 0; i < rowsOccupiedByCurrentManifold.length; i++) {
      let overlap = [];
      overlap = rowsOccupiedByCurrentManifold[i]
        .rowIndexes
        .filter(row => thisManifoldsRows.includes(row));

      hasOverlap = !( overlap.length === 0 );
      if (hasOverlap)
        overlaps.push({
          manifoldId: rowsOccupiedByCurrentManifold[i].manifoldId,
          rowIndexes: overlap
        });
    }

    // is Overlapped?
    if (overlaps.length >= 1) {
      // the overlapped
      const overlappedManifold = this.props["mainManifolds"]
        .find(manifold => manifold.id === overlaps[0].manifoldId);
      // the offender
      const overlappingManifold = this.state.manifold;

      if (prevState.overlappingManifold !== this.state.overlappingManifold) {
        this.setState({ overlappingManifold: overlappingManifold });
      }

      if (!this.props.isOverlapPresent) {
        this.props.toggleOverlapDialog(true, overlappedManifold, overlappingManifold);
      }

      if (!this.props.isOverlapPresent) {
        this.props.setOverlapPresent(true);
      }
    } else {
      this.props.setCheckForOverlap(false);
      if (
        prevState.isOverlapPresent !== undefined &&
        prevState.isOverlapPresent !== this.props.isOverlapPresent
      ) {
        this.props.setOverlapPresent(false);
      }
      this.props.removeOverlappingManifold();
      this.setState({ overlappingManifold: null });
    }
  }

  /**
   * Gets the state settings to be applied to the bypass options inputs
   * @param isIsolator {boolean} - True is the row the manifld is attached to is an isolator row.
   * @param chamberTypeId {string} - The id of the chamber type currently selected.
   * @param accessoryVariant {string} - Name of the chamber structure selected (round || square || nyloplast).
   * @returns {{
   *  hasWeir: boolean,
   *  disableWeir: boolean,
   *  hasElevatedManifold: boolean,
   *  disableElevatedManifold: boolean
   * }}
   */
  getCurrentByPassOptions( isIsolator, chamberTypeId, accessoryVariant ) {
    if (!isIsolator) {
      return {
        hasWeir: false,
        disableWeir: true,
        hasElevatedManifold: false,
        disableElevatedManifold: true
      };
    } else {
      let enableWeir = false, enableElevated = false,
        checkWeir = false, checkElevated = false;
      if (["round", "square"].indexOf(accessoryVariant) >= 0) {
        enableWeir = checkWeir = enableElevated = true;
        if (chamberTypeId === CHAMBER_TYPE_ID_SC160LP) {
          enableWeir = false;
          enableElevated = false;
        }
      } else if (accessoryVariant === "nyloplast") {
        checkElevated = chamberTypeId !== CHAMBER_TYPE_ID_SC160LP;
      }
      return {
        disableWeir: !enableWeir,
        disableElevatedManifold: !enableElevated,
        hasWeir: checkWeir,
        hasElevatedManifold: checkElevated
      };
    }
  }

  /**
   * Dialog Drag handling
   * @param event {Event}
   * @param node {Node}
   */
  handleDragStop( event, node ) {
    if (this.props.x !== node.x || this.props.y !== node.y) {
      this.props.manifoldEntryMoved(node.x, node.y);
    }
  }

  /**
   * Closes Manifold Entry dialog
   */
  handleCloseClick() {
    this.props.closeManifoldEntryDialog();
  }

  /**
   * Toggles isolator for the specific Manifold
   * @param evt {Event}
   * @param value
   */
  handleManifoldIsolatorToggle( evt, value ) {
    evt.preventDefault();
    const manifold = this.props.mainManifolds.find(manifold => manifold._id === this.props["manifoldId"]);
    let payLoad = { "hasIsolator": value };
    if (this.props.accessory.variant !== "nyloplast") {
      if (!value) {
        payLoad["isElevated"] = false;
        payLoad["hasWeir"] = true;
      }
    } else {
      payLoad["isElevated"] = this.props.chamberType.id !== CHAMBER_TYPE_ID_SC160LP;
      payLoad["hasWeir"] = !manifold.isElevated;
    }
    this.resetIsolator(manifold, value);
    this.props.changeMainManifoldProp(this.props.manifoldId, payLoad, ManifoldEntryFormValueType.IS_MANIFOLD_ISOLATOR_ROW);
    this.setState({ hasIsolator: value });
  }

  /**
   * Switches direction of the Manifold
   * @param evt {Event}
   * @param direction {Direction} - key:1 || 2, text: left || right
   */
  handleManifoldDirectionChanged( evt, direction ) {
    evt.preventDefault();
    this.props.changeMainManifoldProp(this.props.manifoldId, direction["key"], ManifoldEntryFormValueType.DIRECTION);
    this.setState({ manifoldDirection: direction["key"] });

    setTimeout(() => {
      //setTimeout is required because the gap calculation requires to be executed after the gap has being changed
      const manifold = this.props.mainManifolds.find(manifold => manifold._id === this.props["manifoldId"]);
      const { numOfRows } = this.props.chamberbed;
      const leftCount = numOfRows - manifold._letRow;

      // STEP 1. check stubWouldHitSecondPipe()
      const newStubRowIndex = manifold._letRow
        + ( ( manifold._spacer * manifold._stubsNumber )
          + ( manifold._manifoldSize.forceManifoldSpacer ? 1 : 0 )
          * ( ( manifold.direction === 2 && manifold._isUpper )
          || ( manifold._direction === 1 && !manifold._isUpper )
            ? 1
            : -1 )
        );

      // Handles the scenario that the new stub would conflict with an
      // opposing (internal) manifold's second pipe connection
      if (manifold._isManifoldInner && ManifoldService
        .stubWouldHitSecondPipe(
          this.props.mainManifolds,
          this.props.chamberRows[newStubRowIndex],
          manifold._letColumn,
          manifold._isUpper
        )) {
        console.error("stubWouldHitSecondPipe === TRUE");
        this.props.changeMainManifoldProp(this.props.manifoldId, ( manifold._direction === 2 ) ? 1 : 2, ManifoldEntryFormValueType.DIRECTION);
        this.props.changeMainManifoldProp(this.props.manifoldId, 1, ManifoldEntryFormValueType.NUMBER_OF_STUBS);
        return;
      }


      let manifoldTypeId = ( manifold._isInlet )
        ? "INLET_MANIFOLD_ID"
        : "OUTLET_MANIFOLD_ID";
      const manifoldConstruct = ManifoldUtils.getManifoldConstruct(
        this.props.chamberType.id,
        manifoldTypeId,
        this.props.totalStorageProvided,
        manifold._isManifoldInner
      );

      let numberOfRows = 0;
      numberOfRows = manifold._manifoldSize.forceManifoldSpacer
        ? manifold._spacer === ManifoldSpacer.gap ? manifold._stubsNumber * 2 + 1 : manifold._stubsNumber + 2
        : manifold._spacer === ManifoldSpacer.gap ? manifold._stubsNumber * 2 : manifold._stubsNumber + 1;
      if (numberOfRows > numOfRows)
        numberOfRows = numOfRows;
      if (numberOfRows === 0)
        numberOfRows = 1;

      const numberOfChambers = ManifoldService.countNumberOfChambersOverManifold(manifold, this.props);
      const oppositeSideChambers = ManifoldService.oppositeSideChambersOnManifoldRequired(manifold, this.props);
      const config = {
        removeTop: manifold._isUpper,
        removeRightToLeft: manifold._direction === 1,
        numberOfRows,
        numberOfChambers,
        oppositeSideChambers,
        remove: true,
        chamberPosition: {
          row: manifold._letRow,
          col: manifold._letColumn
        }
      };

      if (manifold._isManifoldInner) {
        const { stubsArray } = ManifoldService.buildArrayForStubs(manifold, manifold._stubsNumber, numberOfRows, this.props);
        config.numberOfRows = Array.from(new Set(stubsArray.map(sa => sa.row))).length || 1;
        ManifoldService.generateChamberVoid(stubsArray, true, this.props);
        this.props.cleanChambersByManifoldVoidArray(manifold._id, manifold._letRow, manifold._letColumn);
        this.props.cleanChambersByManifoldMainRowArray(manifold._id, manifold._letRow, manifold._letColumn);
        ChamberService.setChamberManifoldIdMeta(
          "isVoidArray",
          ManifoldService.buildManifoldVoidArray(config),
          manifold._letRow,
          manifold._letColumn,
          this.props
        );
        ChamberService.setChamberManifoldIdMeta(
          "isManifoldConnectedArray",
          ManifoldService.getCoordinatesForManifoldActiveRowForMetadata(config),
          manifold._letRow,
          manifold._letColumn,
          this.props
        );
      } else {
        this.props.cleanChambersByManifoldMainRowArray(manifold._id, manifold._letRow, manifold._letColumn);
        ChamberService.setChamberManifoldIdMeta(
          "isManifoldConnectedArray",
          ManifoldService.getCoordinatesForManifoldActiveRowForMetadata(config),
          manifold._letRow,
          manifold._letColumn,
          this.props
        );
      }

      let setStubs = ( !manifold._isManifoldInner )
        ? manifold._stubsNumber
        : this.getStubsNumberFromRows(config.numberOfRows, manifold);
      this.props.changeMainManifoldProp(this.props.manifoldId, setStubs, ManifoldEntryFormValueType.NUMBER_OF_STUBS);

    }, 0);
  }

  /**
   * Handles the state of stubs when incremented or decremented
   * @param change
   * @param numberOfStubs
   */
  handleNumberOfStubsIncrement( change, numberOfStubs ) {
    const currentStubs = parseInt(numberOfStubs, 10);
    const newStubCount = ( currentStubs + change >= 0 ) ? currentStubs + change : 0;
    const manifold = this.props.mainManifolds.find(manifold => manifold._id === this.props["manifoldId"]);
    const prevNumberOfStubs = manifold._stubsNumber + 0;
    const leftCount = this.props.chamberbed.numOfRows - manifold._letRow;
    const rightCount = manifold._letRow;

    // rules about continue with adding or removing stubs.
    const testLeftUpper = ( manifold._direction === 2 && manifold._isUpper && newStubCount >= leftCount );
    const testRightUpper = ( manifold._direction === 1 && manifold._isUpper && newStubCount > manifold._letRow );
    const testRightLower = ( manifold._direction === 2 && !manifold._isUpper && newStubCount > leftCount );
    const testLeftLower = ( manifold._direction === 1 && !manifold._isUpper && newStubCount >= rightCount );

    if (( testRightUpper || testLeftUpper ) && manifold._isInlet) {
      console.error("testRightUpper || testLeftUpper === TRUE, validation for inner manifolds");
      return;
    }
    if (( testLeftLower || testRightLower ) && manifold._isInlet) {
      console.error("testLeftLower || testRightLower === TRUE, validation for inner manifolds");
      return;
    }

    // STEP 1. check stubWouldHitSecondPipe()
    let rowIndexDiff = ( ( manifold._spacer * newStubCount ) + ( newStubCount > 0 && manifold._manifoldSize.forceManifoldSpacer ? 1 : 0 ) );
    rowIndexDiff *= ( ( manifold.direction === 2 && manifold._isUpper ) || ( manifold._direction === 1 && !manifold._isUpper ) ) ? 1 : -1;
    const newStubRowIndex = manifold._letRow + rowIndexDiff;
    // Handles the scenario that the new stub would conflict with an
    // opposing (internal) manifold's second pipe connection
    if (manifold._isManifoldInner && ManifoldService
      .stubWouldHitSecondPipe(
        this.props.mainManifolds,
        this.props.chamberRows[newStubRowIndex],
        manifold._letColumn,
        manifold._isUpper
      )) {
      console.error("stubWouldHitSecondPipe === TRUE");
      return;
    }
    // Step 1 - EOB.

    let manifoldTypeId = ( manifold._isInlet )
      ? "INLET_MANIFOLD_ID"
      : "OUTLET_MANIFOLD_ID";

    const manifoldConstruct = ManifoldUtils.getManifoldConstruct(
      this.props.chamberType.id,
      manifoldTypeId,
      this.props.totalStorageProvided,
      manifold._isManifoldInner
    );

    let numberOfRows = 0;
    numberOfRows =
      newStubCount < 1 ? 1 :
        manifold._manifoldSize.forceManifoldSpacer
          ? manifold._spacer === ManifoldSpacer.gap ? newStubCount * 2 + 1 : newStubCount + 2
          : manifold._spacer === ManifoldSpacer.gap ? newStubCount * 2 : newStubCount + 1;
    if (numberOfRows > this.props.chamberbed.numOfRows)
      numberOfRows = this.props.chamberbed.numOfRows;
    if (numberOfRows === 0)
      numberOfRows = 1;

    const numberOfChambers = ManifoldService.countNumberOfChambersOverManifold(manifold, this.props);
    const oppositeSideChambers = ManifoldService.oppositeSideChambersOnManifoldRequired(manifold, this.props);
    const config = {
      removeTop: manifold._isUpper,
      removeRightToLeft: manifold._direction === 1,
      numberOfRows,
      numberOfChambers,
      oppositeSideChambers,
      remove: true,
      chamberPosition: {
        row: manifold._letRow,
        col: manifold._letColumn
      }
    };

    if (!manifold._isManifoldInner && manifoldTypeId === "OUTLET_MANIFOLD_ID" && newStubCount === 0 && manifoldConstruct.structureType === "nyloplast") {
      config.numberOfRows = 1;
    }

    //if (manifold._isManifoldInner) {
    // STEP 2. Generates void only for added stubs
    // Uses Immer to build a new draft from inmutable
    const newManifold = produce(manifold, manifoldDraft => {
      manifoldDraft._stubsNumber = newStubCount;
    });
    const {
      stubsArray
    } = ManifoldService.buildArrayForStubs(newManifold, prevNumberOfStubs, numberOfRows, this.props);

    if (manifold._isManifoldInner && newStubCount > prevNumberOfStubs) {
      console.table(stubsArray);
      config.numberOfRows = Array.from(new Set(stubsArray.map(s => s.row))).length || 1;
      console.warn(`Number of rows overriden from ${numberOfRows} to ${config.numberOfRows}.`);
    }

    let setStubs = this.getStubsNumberFromRows(config.numberOfRows, manifold);

    ManifoldService.generateChamberVoid(stubsArray, true, this.props);

    // STEP 2. reset chambers meta for manifold, and set them back
    this.props.cleanChambersByManifoldVoidArray(manifold._id, manifold._letRow, manifold._letColumn);
    this.props.cleanChambersByManifoldMainRowArray(manifold._id, manifold._letRow, manifold._letColumn);

    ChamberService.setChamberManifoldIdMeta(
      "isVoidArray",
      ManifoldService.buildManifoldVoidArray(config),
      manifold._letRow,
      manifold._letColumn,
      this.props
    );

    ChamberService.setChamberManifoldIdMeta(
      "isManifoldConnectedArray",
      ManifoldService.getCoordinatesForManifoldActiveRowForMetadata(config),
      manifold._letRow,
      manifold._letColumn,
      this.props
    );

    this.props.changeMainManifoldProp(this.props.manifoldId, setStubs, ManifoldEntryFormValueType.NUMBER_OF_STUBS);
    this.setState({ numberOfStubs: setStubs });
    this.props.setCheckForOverlap(true);
  }

  getStubsNumberFromRows( numOfRows, manifold ) {
    let result = numOfRows
      - 1 // For the direct connection
      + (
        manifold._manifoldSize.forceManifoldSpacer
          ? -1
          : 0
      );
    if (manifold._spacer === ManifoldSpacer.gap)
      result = Math.ceil(result / 2);
    return result;
  }

  /**
   * Validates the number of stubs
   * @param numberOfStubs
   */
  handleNumberOfStubsValidate( numberOfStubs ) {
    const stubs = parseInt(numberOfStubs, 10);
    let newStubCount = ( stubs >= 0 ) ? stubs : 0;

    const manifold = this.props.mainManifolds.find(manifold => manifold._id === this.props["manifoldId"]);
    const prevNumberOfStubs = manifold._stubsNumber + 0;
    const leftCount = this.props.chamberbed.numOfRows - manifold._letRow;
    const rightCount = manifold._letRow;

    // rules about continue with adding or removing stubs.
    const testLeftUpper = ( manifold._direction === 2 && manifold._isUpper && newStubCount >= leftCount );
    const testRightUpper = ( manifold._direction === 1 && manifold._isUpper && newStubCount > manifold._letRow );
    const testRightLower = ( manifold._direction === 2 && !manifold._isUpper && newStubCount > leftCount );
    const testLeftLower = ( manifold._direction === 1 && !manifold._isUpper && newStubCount >= rightCount );

    if (( testRightUpper || testLeftUpper ) && manifold._isInlet) {
      console.error("testRightUpper || testLeftUpper === TRUE, validation for inner manifolds");
      if (manifold._direction === 2) newStubCount = newStubCount - ( newStubCount - leftCount ) - 1;
      if (manifold._direction === 1) newStubCount = newStubCount - ( newStubCount - manifold._letRow );
    }
    if (( testLeftLower || testRightLower ) && manifold._isInlet) {
      console.error("testLeftLower || testRightLower === TRUE, validation for inner manifolds");
      if (manifold._direction === 2) newStubCount = newStubCount - ( newStubCount - leftCount ) - 1;
      if (manifold._direction === 1) newStubCount = newStubCount - ( newStubCount - rightCount );
    }

    // STEP 1. check stubWouldHitSecondPipe()
    let rowIndexDiff = ( ( manifold._spacer * newStubCount ) + ( newStubCount > 0 && manifold._manifoldSize.forceManifoldSpacer ? 1 : 0 ) );
    rowIndexDiff *= ( ( manifold.direction === 2 && manifold._isUpper ) || ( manifold._direction === 1 && !manifold._isUpper ) ) ? 1 : -1;
    const newStubRowIndex = manifold._letRow + rowIndexDiff;
    // Handles the scenario that the new stub would conflict with an
    // opposing (internal) manifold's second pipe connection
    if (manifold._isManifoldInner && ManifoldService
      .stubWouldHitSecondPipe(
        this.props.mainManifolds,
        this.props.chamberRows[newStubRowIndex],
        manifold._letColumn,
        manifold._isUpper
      )) {
      console.error("stubWouldHitSecondPipe === TRUE");
      return;
    }

    // Step 1 - EOB.
    let manifoldTypeId = ( manifold._isInlet )
      ? "INLET_MANIFOLD_ID"
      : "OUTLET_MANIFOLD_ID";

    const manifoldConstruct = ManifoldUtils.getManifoldConstruct(
      this.props.chamberType.id,
      manifoldTypeId,
      this.props.totalStorageProvided,
      manifold._isManifoldInner
    );

    let numberOfRows = 0;
    numberOfRows =
      newStubCount < 1 ? 1 :
        manifold._manifoldSize.forceManifoldSpacer
          ? manifold._spacer === ManifoldSpacer.gap ? newStubCount * 2 + 1 : newStubCount + 2
          : manifold._spacer === ManifoldSpacer.gap ? newStubCount * 2 : newStubCount + 1;
    if (numberOfRows > this.props.chamberbed.numOfRows)
      numberOfRows = this.props.chamberbed.numOfRows;
    if (numberOfRows === 0)
      numberOfRows = 1;

    const numberOfChambers = ManifoldService.countNumberOfChambersOverManifold(manifold, this.props);
    const oppositeSideChambers = ManifoldService.oppositeSideChambersOnManifoldRequired(manifold, this.props);
    const config = {
      removeTop: manifold._isUpper,
      removeRightToLeft: manifold._direction === 1,
      numberOfRows,
      numberOfChambers,
      oppositeSideChambers,
      remove: true,
      chamberPosition: {
        row: manifold._letRow,
        col: manifold._letColumn
      }
    };

    let setStubs = newStubCount;
    if (manifold._isManifoldInner) {
      // STEP 2. Generates void only for added stubs
      // Uses Immer to build a new draft from inmutable
      const newManifold = produce(manifold, manifoldDraft => {
        manifoldDraft._stubsNumber = newStubCount;
      });
      const {
        stubsArray
      } = ManifoldService.buildArrayForStubs(newManifold, prevNumberOfStubs, numberOfRows, this.props);

      if (newStubCount > prevNumberOfStubs) {
        config.numberOfRows = Array.from(new Set(stubsArray.map(s => s.row))).length || 1;
        console.warn(`Number of rows overriden from ${numberOfRows} to ${config.numberOfRows}.`);
      }

      setStubs = this.getStubsNumberFromRows(config.numberOfRows, newManifold);

      ManifoldService.generateChamberVoid(stubsArray, true, this.props);

      // STEP 2. reset chambers meta for manifold, and set them back
      this.props.cleanChambersByManifoldVoidArray(manifold._id, manifold._letRow, manifold._letColumn);
      this.props.cleanChambersByManifoldMainRowArray(manifold._id, manifold._letRow, manifold._letColumn);

      ChamberService.setChamberManifoldIdMeta(
        "isVoidArray",
        ManifoldService.buildManifoldVoidArray(config),
        manifold._letRow,
        manifold._letColumn,
        this.props
      );

      ChamberService.setChamberManifoldIdMeta(
        "isManifoldConnectedArray",
        ManifoldService.getCoordinatesForManifoldActiveRowForMetadata(config),
        manifold._letRow,
        manifold._letColumn,
        this.props
      );
      // Step 2 - EOB.
    } else {
      //Run on external to clean and re set the chambers claimed by the manifold
      this.props.cleanChambersByManifoldMainRowArray(manifold._id, manifold._letRow, manifold._letColumn);
      ChamberService.setChamberManifoldIdMeta(
        "isManifoldConnectedArray",
        ManifoldService.getCoordinatesForManifoldActiveRowForMetadata(config),
        manifold._letRow,
        manifold._letColumn,
        this.props
      );
    }

    this.props.changeMainManifoldProp(this.props.manifoldId, setStubs, ManifoldEntryFormValueType.NUMBER_OF_STUBS);
    this.setState({ numberOfStubs: setStubs });
    this.props.setCheckForOverlap(true);
  }

  /**
   * Modify the number of stubs on the Manifold
   * @param evt {Event}
   * @param gap {boolean} - adds gap or not
   * @returns Void
   */
  handleStubsGapChanged( evt, gap ) {
    evt.preventDefault();
    const spacer = gap ? ManifoldSpacer.gap : ManifoldSpacer.noGap; //gap=2 noGap =1
    this.props.changeMainManifoldProp(this.props.manifoldId, spacer, ManifoldEntryFormValueType.GAP);
    this.setState({ spacer: spacer });

    setTimeout(() => {
      //setTimeout is required because the gap calculation requires to be executed after the gap has being changed
      const manifold = this.props.mainManifolds.find(manifold => manifold._id === this.props["manifoldId"]);

      const { numOfRows } = this.props.chamberbed;
      const leftCount = numOfRows - manifold._letRow;

      if (manifold._spacer === ManifoldSpacer.gap) {
        let newStubNumber = manifold._stubsNumber;
        const doesLeftNotSupportStubs = ( manifold._stubsNumber * 2 ) > leftCount;
        if (manifold._isUpper && doesLeftNotSupportStubs) { // ok
          if (manifold._direction === 2) {
            // newStubNumber = leftCount / 2
          }
          if (manifold._direction === 1) {
            if (manifold._stubsNumber % 2 === 0) {
              newStubNumber = manifold._letRow / 2 + 1;
            } else {
              newStubNumber = manifold._letRow / 2;
            }
          }
        }
        const doesRightNotSupportStubs = ( manifold._stubsNumber * 2 ) > manifold._letRow;
        if (!manifold._isUpper && doesRightNotSupportStubs) {
          if (manifold._direction === 2) {
            // newStubNumber = leftCount / 2
          }
          if (manifold._direction === 1) {
            if (manifold._stubsNumber % 2 === 0) {
              newStubNumber = manifold._letRow / 2 + 1;
            } else {
              newStubNumber = manifold._letRow / 2;
            }
          }
        }
        this.setState(() => {
          return { numberOfStubs: Math.ceil(newStubNumber) };
        });
      }

      let manifoldTypeId = ( manifold._isInlet )
        ? "INLET_MANIFOLD_ID"
        : "OUTLET_MANIFOLD_ID";
      const manifoldConstruct = ManifoldUtils.getManifoldConstruct(
        this.props.chamberType.id,
        manifoldTypeId,
        this.props.totalStorageProvided,
        manifold._isManifoldInner
      );
      let numberOfRows = 0;
      if (manifold._manifoldSize.forceManifoldSpacer) {
        numberOfRows = ( manifold._spacer === ManifoldSpacer.gap ) ? manifold._stubsNumber * 2 + 1 : manifold._stubsNumber + 1;
      } else {
        numberOfRows = ( manifold._spacer === ManifoldSpacer.gap ) ? manifold._stubsNumber * 2 : manifold._stubsNumber + 1;
      }
      if (numberOfRows > numOfRows)
        numberOfRows = numOfRows;
      if (numberOfRows === 0)
        numberOfRows = 1;

      const numberOfChambers = ManifoldService.countNumberOfChambersOverManifold(manifold, this.props);
      const oppositeSideChambers = ManifoldService.oppositeSideChambersOnManifoldRequired(manifold, this.props);
      const config = {
        removeTop: manifold._isUpper,
        removeRightToLeft: manifold._direction === 1,
        numberOfRows,
        numberOfChambers,
        oppositeSideChambers,
        remove: true,
        chamberPosition: {
          row: manifold._letRow,
          col: manifold._letColumn
        }
      };

      if (manifold._isManifoldInner) {
        const { stubsArray } = ManifoldService.buildArrayForStubs(manifold, manifold._stubsNumber, numberOfRows, this.props);

        const newRowsLength = Array.from(new Set(stubsArray.map(s => s.row))).length || 1;
        config.numberOfRows = newRowsLength;

        ManifoldService.generateChamberVoid(stubsArray, true, this.props);
        this.props.cleanChambersByManifoldVoidArray(manifold._id, manifold._letRow, manifold._letColumn);
        this.props.cleanChambersByManifoldMainRowArray(manifold._id, manifold._letRow, manifold._letColumn);
        ChamberService.setChamberManifoldIdMeta(
          "isVoidArray",
          ManifoldService.buildManifoldVoidArray(config),
          manifold._letRow,
          manifold._letColumn,
          this.props
        );
        ChamberService.setChamberManifoldIdMeta(
          "isManifoldConnectedArray",
          ManifoldService.getCoordinatesForManifoldActiveRowForMetadata(config),
          manifold._letRow,
          manifold._letColumn,
          this.props
        );
      } else {
        this.props.cleanChambersByManifoldMainRowArray(manifold._id, manifold._letRow, manifold._letColumn);
        ChamberService.setChamberManifoldIdMeta(
          "isManifoldConnectedArray",
          ManifoldService.getCoordinatesForManifoldActiveRowForMetadata(config),
          manifold._letRow,
          manifold._letColumn,
          this.props
        );
      }

      this.props.changeMainManifoldProp(this.props.manifoldId, manifold._stubsNumber, ManifoldEntryFormValueType.NUMBER_OF_STUBS);

    }, 0);

    this.props.setCheckForOverlap(true);
  }

  /**
   * Modify the number of stubs on the Manifold
   * @param evt {Event}
   * @param selection {boolean} - adds gap or not
   * @returns Void
   */
  handleManifoldSizeChanged( evt, selection ) {
    evt.preventDefault();
    const manifold = this.props.mainManifolds.find(manifold => manifold._id === this.props["manifoldId"]);
    const isNylo = this.props.accessory.variant === "nyloplast";
    const manifoldArray = ManifoldUtils.getManifoldDatasetByChamberId(
      this.props.chamberType.id,
      this.getIsHigh(manifold)
        ? "high"
        : "low",
      isNylo);
    const newSizeObj = ManifoldUtils.getManifoldDatasetObject(manifoldArray, selection["sizeData"]["size"]);
    this.props.changeMainManifoldProp(this.props.manifoldId, newSizeObj, ManifoldEntryFormValueType.MANIFOLD_SIZE);
    this.props.setChamberKeyValue({ manifoldSize: newSizeObj.size }, manifold.letRow, manifold.letColumn);
    this.setState({ selectedManifoldSize: newSizeObj.size });
    this.setPreviousManifoldSize(newSizeObj.size);
  }

  /**
   * changes the manifold size if required
   * @param newSize
   */
  changeManifoldSize( newSize ) {
    const manifold = this.props.mainManifolds.find(manifold => manifold._id === this.props["manifoldId"]);
    const isNylo = this.props.accessory.variant === "nyloplast";
    const manifoldArray = ManifoldUtils.getManifoldDatasetByChamberId(
      this.props.chamberType.id,
      this.getIsHigh(manifold)
        ? "high"
        : "low",
      isNylo);
    const newSizeObj = ManifoldUtils.getManifoldDatasetObject(manifoldArray, newSize);
    this.props.changeMainManifoldProp(this.props.manifoldId, newSizeObj, ManifoldEntryFormValueType.MANIFOLD_SIZE);
    this.props.setChamberKeyValue({ manifoldSize: newSizeObj.size }, manifold.letRow, manifold.letColumn);
    this.setState({ selectedManifoldSize: newSizeObj.size });
  }

  handleHasSecondPipeChanged( evt, value ) {
    evt.preventDefault();
    const manifold = this.props.mainManifolds.find(manifold => manifold._id === this.props["manifoldId"]);

    if (manifold._isManifoldInner) {
      //ManifoldService.validateIsolatorOverOutlet()
      // lets check the oposite chamber, to mark the oposite chamber as used

      // lets check the opposite chamber, to mark the opposite chamber as used
      const increment = manifold._isUpper ? -1 : 1;
      let row = manifold._letRow; //dont move row
      let col = manifold._letColumn + increment;
      let nextChamber = this.props.chamberRows[row].chambers[col];
      let stop = false;
      while (!stop) {
        col += increment;
        nextChamber = this.props.chamberRows[row].chambers[col];
        if (nextChamber.active) stop = true;
      }
      ChamberService.setChamberManifoldIdMeta(
        "isOppositeStubAttached", [{
          col: nextChamber._col,
          row: nextChamber._row,
          value: value
        }], manifold._letRow, manifold._letColumn, this.props
      );

      // Uses Immer to build a nre draft from inmutable
      const newManifold = produce(manifold, manifoldDraft => {
        manifoldDraft._hasSecondPipe = value;
      });
      if (newManifold._hasIsolator) {
        this.resetIsolator(newManifold, true);
        if (value) {
          stop = false;
          col -= increment;
          while (!stop) {
            col += increment;
            nextChamber = this.props.chamberRows[row].chambers[col];
            if (!nextChamber || !nextChamber.active) {
              stop = true;
            } else if (( nextChamber._upperCapActive && nextChamber._upperCapAccessory && nextChamber._upperCapAccessory.id === "Outlet-Manifold" )
              || ( nextChamber._lowerCapActive && nextChamber._lowerCapAccessory && nextChamber._lowerCapAccessory.id === "Outlet-Manifold" )) {
              stop = true;
              this.props.modalAlertActions({
                toggle: true,
                text: this.props.content[this.props.lang]["notAddIsolatorOverOutlet"]
              });
            }
          }
        }
      }
      this.props.changeMainManifoldProp(this.props.manifoldId, value, ManifoldEntryFormValueType.HAS_SECOND_PIPE);
      this.setState({ hasSecondPipe: value });
    }
  }

  handleStructureSelection( option, accessory ) {
    const manifold = this.props.mainManifolds.find(manifold => manifold._id === this.props["manifoldId"]);
    let switchedToNylo = false;
    let updatedAccessory = { ...accessory, variant: option.key };

    // call the set accessory action based on the manifold position
    if (manifold._isUpper) {
      this.props.setChamberUpperCapAccesory(
        manifold.letRow,
        manifold.letColumn,
        updatedAccessory
      );
    } else {
      this.props.setChamberLowerCapAccesory(
        manifold.letRow,
        manifold.letColumn,
        updatedAccessory
      );
    }

    const payLoad = {};
    if (option.key === "nyloplast") {
      switchedToNylo = true;
      payLoad["isElevated"] = this.props.chamberType.id !== CHAMBER_TYPE_ID_SC160LP;
      payLoad["hasWeir"] = false;
    }

    if (option.key === "round") {
      switchedToNylo = false;
      payLoad["isElevated"] = true;
      payLoad["hasWeir"] = false;
    }

    if (option.key === "square") {
      switchedToNylo = false;
      payLoad["isElevated"] = true;
      payLoad["hasWeir"] = false;
    }

    const isHigh = this.getIsHigh(manifold);
    const isNylo = this.props.accessory.variant === "nyloplast" || switchedToNylo;
    const updatedDataset = ManifoldUtils.getManifoldDatasetByChamberId(
      this.props.chamberType.id,
      isHigh
        ? "high"
        : "low",
      isNylo
    );

    if (
      !updatedDataset.find(manifoldSizeObj => manifoldSizeObj.size === manifold.manifoldSize.size)
    ) {
      payLoad["manifoldSize"] = ManifoldUtils.getManifoldDatasetObject(updatedDataset, updatedDataset[0].size);
    }
    this.props.changeMainManifoldProp(this.props.manifoldId, payLoad, ManifoldEntryFormValueType.STRUCTURE_TYPE);
  }

  /**
   * Executes call for hasWeir toggle
   * @param value
   */
  handleHasWeirCheck( value ) {
    this.props.changeMainManifoldProp(this.props.manifoldId, value, ManifoldEntryFormValueType.HAS_WEIR);
    this.setState({ hasWeir: value, hasElevatedManifold: !value });
    if (value
      && this.state.manifold.isInlet
      && this.state.hasIsolator
      && this.state.manifold.isManifoldInner) {
      this.props.modalAlertActions({
        toggle: true,
        text: this.props.content[this.props.lang].showInternalManifoldLowPositionAlertCollision,
        addClassName: "mid-height-alert",
        showAsHtml: true
      });
    }
    this.checkElevationAndSize("weir", value);
  }

  /**
   * Executes call for elevated toggle
   * @param value
   */
  handleElevatedCheck( value ) {
    this.props.changeMainManifoldProp(this.props.manifoldId, value, ManifoldEntryFormValueType.HAS_ELEVATED_MANIFOLD);
    this.setState({ hasElevatedManifold: value, hasWeir: !value });
    this.checkElevationAndSize("isElevated", value);
  }

  checkElevationAndSize( type, value ) {
    try {
      const updatedDataset = ManifoldUtils.getManifoldDatasetByChamberId(
        this.props.chamberType.id,
        type === "isElevated" && value || type === "weir" && !value
          ? "high"
          : "low",
        this.props.accessory.variant === "nyloplast"
      );

      if (
        !updatedDataset.find(manifoldSizeObj => manifoldSizeObj.size === this.state.manifold.manifoldSize.size)
      ) {
        const newSize = ManifoldUtils.getManifoldDatasetObject(updatedDataset, updatedDataset[0].size);
        this.props.changeMainManifoldProp(this.props.manifoldId, newSize, ManifoldEntryFormValueType.MANIFOLD_SIZE);
      }
    } catch (ex) {
      console.error("Exception running checkElevationAndSize()::", ex);
    }
  }

  /**
   * Handles overlapping allowing edit of Manifold or showing dialog
   * @param editExisting
   */
  handleOverlapDialogClose( editExisting ) {
    this.props.setOverlapPresent(true);
    if (editExisting) {
      const existingManifold = this.props.overlappedManifold;
      const accessoryProp = existingManifold.isUpper ? "upperCapAccessory" : "lowerCapAccessory";
      const accessory = this.props.chamberRows[existingManifold.letRow].chambers
        .find(c => {
          if (c[accessoryProp] && c[accessoryProp].manifoldId && existingManifold.id) {
            return c[accessoryProp].manifoldId === existingManifold.id;
          }
          return [];
        })[accessoryProp];
      this.props.setCheckForOverlap(true);
      this.props.showManifoldEntryDialog(existingManifold.id, accessory);
    } else {
      this.props.toggleOverlapDialog(false, null, this.state.overlappingManifold);
    }
    setTimeout(() => {
      this.props.setCheckForOverlap(true);
    }, 2000);
    //
  }

  /**
   * Handle manifold dialog remove or edit
   * @param remove
   */
  handleRemovalPromptDialogClose( remove ) {

    if (remove) {
      if (
        ManifoldSelectors.countOutlets() === 1
        && this.state.manifold.isOutlet
        && this.props.hasImperviousLiner
      ) {
        this.setState({ includeImperviousLinerWaringError: true });
        this.props.closeRemovalPromptDialog();
        return null;
      }
      this.props.removeManifold(this.state.manifold);
      this.props.cleanChambersByArrayIsolator(
        this.state.manifold._id,
        this.state.manifold._letRow,
        this.state.manifold._letColumn
      );
    } else {
      this.props.closeRemovalPromptDialog();
    }
  }

  /**
   * Main Render
   * @return {JSX.Element}
   */
  render() {
    const {
      content,
      lang,
      showManifoldEntry,
      showOverlapDialog,
      promptForRemoval
    } = this.props;
    if (showManifoldEntry) {
      return (
        <React.Fragment>
          <Dialog
            hidden={!promptForRemoval}
            dialogContentProps={{
              type: DialogType.normal,
              title: content[lang].editOrRemoveManifold,
              subText: content[lang].editOrRemoveManifoldSubText
            }}
            minWidth={"400px"}
            modalProps={{
              isBlocking: true
            }}>
            <DialogFooter>
              <PrimaryButton
                onClick={() => this.handleRemovalPromptDialogClose(false)}
                text={content[lang].editOrRemoveManifoldEditButton}
                className="edit-new-manifold"
              />
              <DefaultButton
                onClick={() => this.handleRemovalPromptDialogClose(true)}
                text={content[lang].editOrRemoveManifoldRemoveButton}
                className="edit-existing-manifold"
              />
            </DialogFooter>
          </Dialog>
          <Dialog
            hidden={!showOverlapDialog}
            dialogContentProps={{
              type: DialogType.normal,
              title: content[lang].overlappingManifold
            }}
            minWidth={"500px"}
            modalProps={{
              className: "overlap-dialog",
              isBlocking: true
            }}>
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-sm4 ms-md4 ms-lg4">
                <PrimaryButton
                  onClick={() => this.handleOverlapDialogClose(false)}
                  text={content[lang].editNewManifoldButton}
                  className="edit-new-manifold"
                />
              </div>
              <div className="ms-Grid-col ms-sm8 ms-md8 ms-lg8">
                <p className="manifold-helper-text">{content[lang].editNewManifoldText}</p>
              </div>
            </div>
            <div className="ms-Grid-row" style={{ marginTop: "5px" }}>
              <div className="ms-Grid-col ms-sm4 ms-md4 ms-lg4">
                <PrimaryButton
                  onClick={() => this.handleOverlapDialogClose(true)}
                  text={content[lang].editExistingManifoldButton}
                  className="edit-existing-manifold"
                />
              </div>
              <div className="ms-Grid-col ms-sm8 ms-md8 ms-lg8">
                <p className="manifold-helper-text">{content[lang].editExistingManifoldText}</p>
              </div>
            </div>
          </Dialog>
          <Draggable
            onStop={this.handleDragStop.bind(this)}
            bounds="#layout"
            handle=".handle"
            position={{ x: this.props.x, y: this.props.y }}>
            <div className="ManifoldEntry">
              <div className="handle">
                                <span className="closeButtom"
                                      onClick={this.handleCloseClick.bind(this)}>
                                    X
                                </span>
              </div>
              {this.renderDialogContent()}
            </div>
          </Draggable>
          <Dialog
            hidden={!this.state.includeImperviousLinerWaringError}
            dialogContentProps={{
              type: DialogType.normal,
              title: content[lang].imperviousLinerWarningTitle,
              subText: content[lang].imperviousLinerWarning2
            }}
            modalProps={{
              isBlocking: false,
              containerClassName: "alert-level-container alert-level-3-container"
            }}
          >
            <DialogFooter>
              <DefaultButton
                onClick={() => {
                  this.setState({ includeImperviousLinerWaringError: false });
                }}
                text={content[lang].cancel}
                className={"outline_grey_ads"}
              />
            </DialogFooter>
          </Dialog>
        </React.Fragment>
      );
    } else {
      return <span style={{ display: "none" }} />;
    }
  };

  /**
   * Renders the form inside the dialog
   * @returns {*}
   */
  renderDialogContent() {
    const debug = false;
    const directionImgSrc = require(`../../media/chambers/${this.props.lang.substring(0, 2)}/manifold_entry_direction.png`);
    const {
      manifold,
      isIsolator,
      hasElevatedManifold,
      hasWeir,
      manifoldDirection,
      numberOfStubs,
      selectedManifoldSize
    } = this.state;
    const {
      content,
      lang,
      accessory,
      chamberType,
      unit,
      lbl
    } = this.props;


    const isHigh = this.getIsHigh(manifold);
    const isNylo = this.props.accessory.variant === "nyloplast";
    this.manifoldDataset = ManifoldUtils.getManifoldDatasetByChamberId(chamberType.id, isHigh ? "high" : "low", isNylo);
    let dropDownStructure = ManifoldUtils.getManifoldDatasetForUIArray(this.manifoldDataset, unit);
    return (
      <div className="manifold-entry-options">
        <div className="manifold-entry-row ms-Grid-row">
          <div className="ms-Grid-col ms-sm4 ms-md4 ms-lg4">
            {manifold && manifold.isInlet &&
              <div>
                <div>
                  <label style={{ marginRight: "5px" }}>{content[lang].isolatorRow}:</label>
                  {( lang === languageIds.frFR || lang === languageIds.deDE ) &&
                    ( <span style={{ float: "right" }}><PopUpHelper
                      text={content[lang].isolatorRowPlusPopup}
                    /></span> )
                  }
                </div>
                <Toggle
                  className="manifold-entry-toggle"
                  onText={content[lang].yes}
                  offText={content[lang].no}
                  checked={this.state.hasIsolator}
                  onChange={this.handleManifoldIsolatorToggle.bind(this)} />
              </div>
            }
          </div>
          <div className="ms-Grid-col ms-sm8 ms-md8 ms-lg8" style={{ float: "right", paddingRight: "30px" }}>
            <div className="flow-rate ms-Grid-row">
              <div className="ms-Grid-col ms-sm-6 ms-md-6 ms-lg-6">
                <label className="flow-rate-title">{content[lang].estimatedFlowRate}</label>
              </div>
              <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg6"
                   style={{ display: "flex", alignItems: "center" }}>
                <label className="flow-rate-result">
                  {
                    this.convertUnit(
                      this.calculateManifoldFlowRate(this.state.manifold)
                    )
                  }
                  &nbsp;
                  {
                    lbl[unit].cfs[lang]
                  }
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="manifold-entry-row">
          <label>{content[lang].selectedStructure}:</label>
          <ComboBox
            className="manifold-entry-combo"
            disabled={!accessory}
            selectedKey={accessory ? accessory.variant : null}
            options={[
              {
                key: "round",
                text: content[lang].round
              },
              {
                key: "square",
                text: content[lang].square
              },
              {
                key: "nyloplast",
                text: "Nyloplast",
                disabled: this.props.chamberType.id === CHAMBER_TYPE_ID_SC160LP && !!manifold && manifold.isInlet && isIsolator
              }
            ]}
            onChange={( evt, option ) => {
              this.handleStructureSelection(option, accessory);
            }} />
        </div>
        {
          manifold && manifold.isInlet &&
          <React.Fragment>
            <label>{content[lang].selectBypass}:</label>
            <div className="manifold-entry-row">
              <div style={{ marginBottom: "5px" }}>
                <Checkbox
                  label={content[lang].elevatedManifold}
                  className="manifold-entry-choice"
                  disabled={this.state.disableElevatedManifold}
                  checked={hasElevatedManifold}
                  onChange={( evt, checked ) => {
                    evt.preventDefault();
                    this.handleElevatedCheck(checked);
                  }} />
              </div>
              <div>
                <Checkbox
                  label={content[lang].weir}
                  className="manifold-entry-choice"
                  style={{ maxHeight: 300 }}
                  disabled={this.state.disableWeir}
                  checked={hasWeir}
                  onChange={( evt, checked ) => {
                    evt.preventDefault();
                    this.handleHasWeirCheck(checked);
                  }} />
              </div>
            </div>
          </React.Fragment>
        }
        <div className="manifold-entry-row">
          <label>{content[lang].selectManifoldSize} ({lbl[unit].in[lang]}):</label>
          <ComboBox
            className="manifold-entry-combo manifold-size"
            styles={{ optionsContainer: { maxHeight: "415px" } }}
            selectedKey={selectedManifoldSize}
            options={dropDownStructure}
            onChange={this.handleManifoldSizeChanged.bind(this)} />
        </div>
        <div className="manifold-entry-row ms-Grid-row">
          <div className="ms-Grid-col ms-sm4 ms-md4 ms-lg4">
            <label>{content[lang].manifoldDirection}:</label>
            <ChoiceGroup
              className="manifold-entry-combo"
              selectedKey={manifoldDirection}
              options={[
                {
                  key: ManifoldDirection.Left,
                  text: `${content[lang].left[0].toUpperCase()}${content[lang].left.slice(1)}`,
                  styles: { field: { marginTop: "0px" } }
                }, {
                  key: ManifoldDirection.Right,
                  text: `${content[lang].right[0].toUpperCase()}${content[lang].right.slice(1)}`,
                  styles: { field: { marginTop: "0px" } }
                }
              ]}
              onChange={this.handleManifoldDirectionChanged.bind(this)} />
          </div>
          <div className="ms-Grid-col ms-sm8 ms-md8 ms-lg8" style={{ height: "100px" }}>
            <img className="direction-image" alt="" src={directionImgSrc} height={"100%"} width={"100%"} />
          </div>
        </div>
        <div className="manifold-entry-row">
          <label>{content[lang].enterNumberOfStubs}:</label>
          <SpinButton
            className="manifold-entry-text"
            value={numberOfStubs}
            type="number"
            onIncrement={this.handleNumberOfStubsIncrement.bind(this, 1)}
            onDecrement={this.handleNumberOfStubsIncrement.bind(this, -1)}
            onValidate={this.handleNumberOfStubsValidate.bind(this)}
            min={0}
          />
        </div>
        <div className="manifold-entry-row" style={{ display: "flex" }}>
          <label style={{ marginRight: "5px" }}>{content[lang].stubsEveryOtherRow}:</label>
          <Toggle
            className="manifold-entry-toggle"
            onText={content[lang].yes}
            offText={content[lang].no}
            checked={this.state.spacer}
            /*disabled={this.props.chamberType.id === CHAMBER_TYPE_ID_SC160LP}*/
            onChange={this.handleStubsGapChanged.bind(this)}
          /><br />
        </div>
        <div className="manifold-entry-row" style={{ display: "flex" }}>
          <label style={{ marginRight: "5px" }}>{content[lang].hasSecondDirectPipe}:</label>
          <Toggle
            className="manifold-entry-toggle"
            disabled={this.state.disableSecondPipe}
            onText={content[lang].yes}
            offText={content[lang].no}
            checked={this.state.hasSecondPipe}
            onChange={this.handleHasSecondPipeChanged.bind(this)}
          /><br />
        </div>
        {debug && (
          <div className="ms-Grid-col">
            <div className="ms-Grid-row ms-sm12 ms-md12 ms-lg12"
                 style={{ fontSize: "9px" }}>_id: {this.state.manifold && this.state.manifold.id}</div>
          </div>
        )}
      </div>
    );
  }

  /**
   * cfs calculation or conversion to metric
   * @param val
   * @return {string}
   */
  convertUnit( val ) {
    const cfs = ( Math.round(100 * val) / 100 ).toFixed(2);
    if (this.props.unit === unitIds.metric) {
      return ( cfs * 28.316846592 ).toFixed(0);
    } else {
      return cfs;
    }
  }

  /**
   * tests if manifold is elevated
   * @param manifold
   * @return {boolean|*}
   */
  getIsHigh( manifold ) {
    if (!this.state.isIsolator || this.props.chamberType.id === CHAMBER_TYPE_ID_SC160LP)
      return false;
    else if (this.props.accessory.variant === "nyloplast")
      return true;
    else
      return manifold ? manifold.isElevated : this.state.hasElevatedManifold;
  }

  /**
   * Flow rate calculation for Inlets and Outlets
   * @param manifold
   * @return {number}
   */
  calculateManifoldFlowRate( manifold ) {
    if (!manifold) return 0;

    const isHigh = this.getIsHigh(manifold);

    const stubFlowRate = isHigh
      ? parseFloat(manifold.manifoldSize.highFlowRate)
      : parseFloat(manifold.manifoldSize.lowFlowRate);

    const trunkMaxFlowRate = isHigh
      ? parseFloat(manifold.manifoldSize.highTrunkMaxFlowRate)
      : parseFloat(manifold.manifoldSize.lowTrunkMaxFlowRate);

    const calcFlowRate = Math.round(stubFlowRate * manifold.stubsNumber * 100) / 100;

    const inletFinalRate = calcFlowRate > trunkMaxFlowRate ? trunkMaxFlowRate : calcFlowRate;
    const outletFinalRate = ManifoldUtils.calculateOutletManifoldFlowRate(
      manifold.manifoldSize.size,
      manifold.manifoldSize.isolatorStubSize,
      manifold._stubsNumber
    );
    return manifold.isInlet
      ? inletFinalRate
      : outletFinalRate;
  }

  resetIsolator( manifold, enableIsolator ) {
    const newManifold = produce(manifold, manifoldDraft => {
      manifoldDraft._hasIsolator = enableIsolator;
    });
    if (enableIsolator) {
      IsolatorService.setIsolator(newManifold, this.props.chamberbed, this.props);
    } else {
      this.props.setManifoldIsolatorRowStatus(newManifold.letRow, newManifold.letColumn, newManifold.id, false);
    }
  }
}

const mapStateToProps = state => {
  return {
    content: state.localization.content,
    lang: state.localization.lang,
    lbl: state.localization.lbl,
    unit: state.localization.unit,

    x: state.manifoldEntry.x,
    y: state.manifoldEntry.y,
    accessory: state.manifoldEntry.accessory,
    manifoldId: state.manifoldEntry.manifoldId,
    showManifoldEntry: state.manifoldEntry.showManifoldEntryDialog,
    checkForOverlap: state.manifoldEntry.checkForOverlap,
    overlappedManifold: state.manifoldEntry.overlappedManifold,
    showOverlapDialog: state.manifoldEntry.showOverlapDialog,
    promptForRemoval: state.manifoldEntry.promptForRemoval,
    isOverlapPresent: state.manifoldEntry.overlapPresent,


    upperManifolds: ManifoldSelectors.getManifoldsByType("upper"),
    lowerManifolds: ManifoldSelectors.getManifoldsByType("lower"),
    mainManifolds: state.mainManifolds.manifolds,

    upperFlowPerStub: ManifoldSelectors.getManifoldsSizingByTypeAndProperty("upper", "flowPerStub"),
    lowerFlowPerStub: ManifoldSelectors.getManifoldsSizingByTypeAndProperty("lower", "flowPerStub"),

    upperMaxFlowRate: ManifoldSelectors.getManifoldsSizingByTypeAndProperty("upper", "maximumFlowRate"),
    lowerMaxFlowRate: ManifoldSelectors.getManifoldsSizingByTypeAndProperty("lower", "maximumFlowRate"),


    chamberRows: state.chamberbed.chamberRows,
    chamberType: state.globals.chamberType,
    chamberbed: state.chamberbed,
    totalStorageProvided: state.calculations.totalStorageProvided,
    insertaTeeWarningType: state.chamberbed.insertaTeeWarningType,
    hasImperviousLiner: state.calculations.hasImperviousLiner
  };
};

const mapDispatchToProps = {
  manifoldEntryMoved,
  switchToAddMode,
  showManifoldEntryDialog,
  closeManifoldEntryDialog,
  setManifoldIsolatorRowStatus,
  setChamberUpperCapAccesory,
  setChamberLowerCapAccesory,
  renderUpperManifolds,
  renderLowerManifolds,
  renderMainManifolds,
  setCheckForOverlap,
  toggleOverlapDialog,
  removeOverlappingManifold,
  removeManifold,
  cleanChambersByArrayIsolator,
  closeRemovalPromptDialog,
  setOverlapPresent,
  setCurrentManifold,
  activateByArray,
  deactivateByArray,
  modifyChambersByArray,
  modifyChambersByArrayIsolator,
  setChamberKeyValue,
  changeMainManifoldProp,
  modifyChambersByManifoldVoidArray,
  cleanChambersByManifoldVoidArray,
  cleanChambersByManifoldMainRowArray,
  modalAlertActions,
  showInsertaTeeWarning,
  setInsertaTeeWarningType
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManifoldEntry);



// WEBPACK FOOTER //
// ./src/components/ManifoldEntry/index.js